module.exports = __webpack_public_path__ + "img/分区10.177b80a4.png";